import cn from 'clsx'

const HEADER_OPACITY_CLASSES =
  'bg-dark/10 bg-dark/20 bg-dark/30 bg-dark/40 bg-dark/50 bg-dark/60 bg-dark/70 bg-dark/80 bg-dark/90'

export const HeaderOpacityClasses = () => (
  <div className={cn(HEADER_OPACITY_CLASSES)} />
)
